export const MAX_SELECTED_ACQUISITION_ORDERS = 30;

export const batchEditModes = {
  ADD: 'add',
  REPLACE: 'replace',
};

export default batchEditModes;
